import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { ConsumiblesCategoryRedux } from '../Redux/ConsumiblesCategoryRedux'

const consumiblesCategoryCrudObservable = createCRUDObservable({
  mainRedux: ConsumiblesCategoryRedux,
  reduxPath: 'consumiblesCategory',

})

export const consumiblesCategoryObservers = Object.assign({}, consumiblesCategoryCrudObservable.observers, {})

export const consumiblesCategoryEpic = combineEpics(
  consumiblesCategoryCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ConsumiblesCategoryObservable.js